import { Component, OnInit, EventEmitter, Output, Input } from '@angular/core';
import { OrganizationService } from '../../shared/services/organization.service'
import { Router, ActivatedRoute, Params, RouterLink} from '@angular/router';
import { MatSnackBar } from '@angular/material';
import { AuthService } from '../../shared/services/auth/auth.service';
import {Sort} from '@angular/material';

@Component({
  selector: 'app-team-list',
  templateUrl: './team-list.component.html',
  styleUrls: ['./team-list.component.css']
})
export class TeamListComponent implements OnInit {
  @Input() companyLeaderShip;
  public isLoading: Boolean = false;
  public live: Boolean = true;
  public archived: Boolean = false;
  // variables for ACL
  public isAdmin: Boolean = false;
  public isLeader: Boolean = false;
  public isAssociate: Boolean = true;
  public currentUserId: string;
  public teamsArchived = [];
  public teamsActive = [];
  public teamsAll = [];

  public teams =  [];
  public organizationId: string;
  public teamNameSearch: string;
  public parentTeamSearch: string;
  public parentTeamslist = [];

  @Output() swipedOn = new EventEmitter<string>();
  constructor( public organizationService: OrganizationService,
              public route: ActivatedRoute,
              public router: Router,
              public snackBar: MatSnackBar,
              public authService: AuthService ) { }

  ngOnInit() {
    this.currentUserId = this.authService.user.associateId;
      this.organizationId = this.organizationService.organizationId;
      console.log(this.currentUserId, this.organizationService.hrLeaderId, this.organizationService.companyLeaderId);
      if (this.authService.user.role === 'Admin') {
        this.isAdmin = true;
        this.isLeader = false;
        this.isAssociate = false;
      } else if (this.currentUserId === this.organizationService.hrLeaderId
        || this.currentUserId === this.organizationService.companyLeaderId ||
        (this.companyLeaderShip.hrTeamIds.indexOf(this.currentUserId) > -1) ) {
        this.isAdmin = false;
        this.isLeader = true;
        this.isAssociate = false;
      } else {
        this.isAdmin = false;
        this.isLeader = false;
        this.isAssociate = true;
      }
      this.isLoading = true;
    this.organizationService.readTeams(this.organizationId).subscribe((data) => {
      this.isLoading = false;
      console.log('data',data);
      this.teamsActive = data[0].teams.filter (team => team.active === true);
      this.teamsArchived  = data[0].teams.filter (team => team.active === false);
      this.teamsAll = data[0].teams;
      this.teams = Object.assign([], this.teamsActive);
      this.parentTeamslist = this.teams;
    }, (error) => {
      this.isLoading = false;
      this.snackBar.open('There has been a problem while loading teams.', '', {
        duration: 3000
      });
    });
  }

  onChange(event) {
 if (this.live === true && this.archived === false) {
  this.teams = Object.assign([], this.teamsActive );
 } else if (this.live === false && this.archived === true) {
  this.teams = Object.assign([], this.teamsArchived);
 } else if (this.live === true && this.archived === true) {
  this.teams = Object.assign([],  this.teamsArchived);
   } else if (this.live === false && this.archived === false) {
    this.teams = Object.assign([],  this.teamsAll);
     }
  }

  sortData(sort: Sort) {
    const data = this.teams.slice();
    if (!sort.active || sort.direction === '') {
      this.teams = data;
      return;
    }

    this.teams = data.sort((a, b) => {
      let isAsc = sort.direction === 'asc';
      switch (sort.active) {
        case 'teamDetail.parentTeam.name': return this.compare(a.teamDetail.parentTeam.name, b.teamDetail.parentTeam.name, isAsc);
        case 'members.associates.length': return this.compare(a.members.associates.length, b.members.associates.length, isAsc);
        case 'teamLevel': return this.compare(a.teamLevel, b.teamLevel, isAsc);
        case 'teamDetail.size': return this.compare(a.teamDetail.size, b.teamDetail.size, isAsc);
        default: return 0;
      }
    });
  }
  compare(a, b, isAsc) {
    return (a < b ? -1 : 1) * (isAsc ? 1 : -1);
  }
  swipe(event) {
    console.log('Reached team event handler', event);
    this.swipedOn.emit(event);
  }

}
